import { LegalLayout, LegalSection } from "@/components/LegalLayout";
import { COMPANY } from "@/lib/site";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="August 2026" testid="terms-page">
      <p>
        These Terms of Service ("Terms") govern your use of the software products and websites
        operated by {COMPANY.name} ("Aumonline", "we", "us"), including Kreta, Apoopika and
        Jigyasa (each a "Service"). By creating an account or using a Service, you agree to these
        Terms. If you do not agree, please do not use the Service.
      </p>

      <LegalSection heading="1. Who we are">
        <p>
          Aumonline is a business based in Mysuru, Karnataka, India, that builds and operates
          subscription software for small and medium businesses. Our registered office is
          {" "}{COMPANY.addressLine1}, {COMPANY.addressLine2}.
        </p>
      </LegalSection>

      <LegalSection heading="2. Accounts">
        <p>
          You must provide accurate information when you register and keep your login details
          secure. You are responsible for all activity under your account. You must be authorised
          to act for the business you register.
        </p>
      </LegalSection>

      <LegalSection heading="3. Free trial">
        <p>
          Each Service offers a 14-day free trial. No payment details are taken to start a trial,
          and you may stop using the Service at any time before it ends without being charged.
          When a trial ends without a paid subscription, your account becomes read-only: you can
          view your data but not add or change it. Your data is preserved, and starting a paid
          subscription restores full access.
        </p>
      </LegalSection>

      <LegalSection heading="4. Subscriptions and payment">
        <p>
          After the free trial, continued use of a Service requires a paid subscription.
          Subscriptions are billed monthly or yearly at the prices published on each Service's own
          website. Published prices are the total amount payable: Aumonline is not registered for
          GST, so no GST or other tax is charged or added. Payment is collected within each
          Service; this website does not process payments.
        </p>
        <p>
          For Kreta, a "hub" means one physical location at one postal address. Kreta plans are
          priced per hub, with no limit on the number of members or staff users at a hub.
        </p>
        <p>
          If a renewal payment is not received when due, your account keeps full access for 7 days
          while we notify you of the missed payment. After those 7 days the account becomes
          read-only until payment is received. Your data is preserved throughout, and paying
          restores full access.
        </p>
        <p>
          If you upgrade your plan, the upgrade applies immediately and any unused paid days on
          your old plan are converted into free days on the new plan. If you downgrade, the
          downgrade takes effect from your next billing date.
        </p>
      </LegalSection>

      <LegalSection heading="5. Cancellation and refunds">
        <p>
          You may cancel a subscription at any time. Cancellation, access periods and refunds are
          described in our Refund &amp; Cancellation Policy, which forms part of these Terms.
        </p>
      </LegalSection>

      <LegalSection heading="6. Acceptable use">
        <p>
          You agree not to misuse a Service — including attempting to break its security, using it
          to store unlawful content, or interfering with other users. We may suspend accounts that
          breach these Terms or applicable law.
        </p>
      </LegalSection>

      <LegalSection heading="7. Your data">
        <p>
          You own the business and customer records you enter into a Service. Our handling of that
          data is described in our Privacy Policy.
        </p>
      </LegalSection>

      <LegalSection heading="8. Service provided 'as is'">
        <p>
          Each Service is provided on an "as is" and "as available" basis. While we work to keep
          the Services reliable, we do not guarantee they will be uninterrupted or error-free. To
          the extent permitted by law, Aumonline is not liable for indirect or consequential loss,
          and our total liability for any claim is limited to the subscription fees you paid for
          the relevant Service in the three months before the claim.
        </p>
      </LegalSection>

      <LegalSection heading="9. Changes to these Terms">
        <p>
          We may update these Terms from time to time. If we make a significant change, we will
          make the updated Terms available on our website. Continued use of a Service after a
          change means you accept the updated Terms.
        </p>
      </LegalSection>

      <LegalSection heading="10. Governing law">
        <p>
          These Terms are governed by the laws of India. Any dispute is subject to the exclusive
          jurisdiction of the courts of {COMPANY.city}, Karnataka.
        </p>
      </LegalSection>

      <LegalSection heading="11. Contact">
        <p>
          Questions about these Terms? Email us at {COMPANY.email} or call {COMPANY.phoneDisplay}.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
